import { render, staticRenderFns } from "./guShiWen.vue?vue&type=template&id=ca52be18&scoped=true&"
import script from "./guShiWen.vue?vue&type=script&lang=js&"
export * from "./guShiWen.vue?vue&type=script&lang=js&"
import style0 from "./guShiWen.vue?vue&type=style&index=0&id=ca52be18&prod&lang=scss&"
import style1 from "./guShiWen.vue?vue&type=style&index=1&id=ca52be18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca52be18",
  null
  
)

export default component.exports